import pick from 'lodash.pick';

import { endpoints } from '../services/amplify-api/endpoints';
import {
  SetCrmConnector,
  SetCrmEditMode,
  SetIsInitialSave,
  SetAccountKeys,
  SetCrmConnectorType,
  SetCrmDto,
  SetCrmLoading,
  SetKeysLoading,
  SetSelectedKeys,
  SetEditSettings,
} from '@/constants/mutations';
import { FetchCrmConnector, SaveCrmConnector, FetchAccountKeys } from '@/constants/actions';
import { GetAvailableAccountKeys } from '@/constants/getters';

const defaultState = () => ({
  loading: false,
  keysLoading: false,
  isEditMode: false,
  crmConnector: null,
  selectedConnectorType: '',
  crmDto: null,
  accountKeys: [],
  selectedKeys: [],
  initialSave: false,
  editSettings: false,
});

export const state = defaultState;

export const mutations = {
  [SetCrmConnector](state, data) {
    state.crmConnector = data;
  },

  [SetCrmEditMode](state, data) {
    state.isEditMode = data;
  },

  [SetCrmDto](state, data) {
    state.crmDto = data;
  },

  [SetAccountKeys](state, data) {
    state.accountKeys = data;
  },

  [SetSelectedKeys](state, data) {
    state.selectedKeys = data;
  },

  [SetCrmConnectorType](state, data) {
    state.selectedConnectorType = data;
  },

  [SetIsInitialSave](state, data) {
    state.initialSave = data;
  },

  [SetKeysLoading](state, data) {
    state.keysLoading = data;
  },

  [SetCrmLoading](state, data) {
    state.loading = data;
  },

  [SetEditSettings](state, data) {
    state.editSettings = data;
  },
};

export const actions = {
  async [FetchCrmConnector]({ commit }) {
    try {
      commit(SetCrmLoading, true);
      const { data } = await this.$amplifyApi.get(endpoints.crm.connector);
      commit(SetCrmConnectorType, data.type);
      commit(SetCrmConnector, data);
      commit(SetCrmDto, data);
      return data;
    } catch (err) {
      commit(SetIsInitialSave, true);
    } finally {
      commit(SetCrmLoading, false);
    }
  },

  async [FetchAccountKeys]({ commit }) {
    try {
      commit(SetKeysLoading, true);
      const response = await this.$amplifyApi.get(endpoints.crm.getAccountKeys);
      commit(SetAccountKeys, response.data);
      return response;
    } catch (err) {
      console.error(err);
    } finally {
      commit(SetKeysLoading, false);
    }
  },

  async [SaveCrmConnector]({ commit, state }, { data, initialSave = false }) {
    try {
      const response = await this.$amplifyApi.post(
        endpoints.crm.connector,
        pick(data, ['endpointUrl', 'credentials', 'settings', 'accountIdentifier', 'type'])
      );

      commit(SetIsInitialSave, initialSave);
      commit(SetCrmConnector, response.data);
      commit(SetCrmDto, { ...state.crmDto, ...response.data });
      return response;
    } catch (err) {
      console.error(err);
    }
  },
};

export const getters = {
  [GetAvailableAccountKeys]: (state) => state.crmConnector?.settings?.accountKeys || [],
};
